export default __webpack_public_path__ + "static/media/prism.efb641b1.svg";